import { createAction } from '@reduxjs/toolkit';
import { authorizedFetch } from '../utils';

export const updateName = createAction('updateName');

export const fetchHomePageDashboard = async () => {
  const response = await authorizedFetch(
    '/api/minionuisettings?id=home-dashboard',
    'GET'
  );
  const data = await authorizedFetch(
    `/api/report/${response?.data?.reportId}`,
    'GET'
  );
  return data;
};

export const setHomePageDashboard = url => {
  const dashboard = {
    id: 'home-dashboard',
    data: {
      url: url
    }
  };

  return new Promise((resolve, reject) => {
    authorizedFetch('/api/minionuisettings', 'POST', dashboard)
      .then(response => {
        resolve(response);
      })
      .catch(e => {
        reject(e);
      });
  });
};
